import { render } from "./UserDeleteModal.vue?vue&type=template&id=2f15ca3d&scoped=true&ts=true"
import script from "./UserDeleteModal.vue?vue&type=script&lang=ts"
export * from "./UserDeleteModal.vue?vue&type=script&lang=ts"

import "./UserDeleteModal.vue?vue&type=style&index=0&id=2f15ca3d&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f15ca3d"]])

export default __exports__